import React from "react";
import PropTypes from "prop-types";
//import material-ui components
import withStyles from "@material-ui/core/styles/withStyles"
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
//import material icons
import Close from "@material-ui/icons/Close";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput";
import GridItem from "components/Grid/GridItem";


import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

class NewReportDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            name: "",
            reportSubjectId: "",
            description: "",
            machineId: "",
        };
    }

    _changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    render(){
        const { classes, onCancel, onSave, isOpened } = this.props;
        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={isOpened}
                onClose={() => onCancel()}
            >
                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}
                >
                    <IconButton
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => onCancel()}
                    >
                        <Close className={classes.modalClose} />
                    </IconButton>
                    <h4 className={classes.modalTitle} >Создание новой заявки</h4>
                </DialogTitle>
                <DialogContent className={classes.modalBody}>
                    <Grid container>
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Название"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    value: this.state.name,
                                    onChange: e => this._changeValue(e, "name")
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12} md={6}>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel>Аппарат</InputLabel>
                                <Select
                                    value={this.state.machineId}
                                    onChange={(e) => this._changeValue(e, "machineId")}
                                    inputProps={{
                                        name: 'machineId',
                                    }}
                                    className={classes.select}
                                >
                                    <MenuItem value=""><em>По умолчанию</em></MenuItem>
                                    {this.props.machines && this.props.machines.map((org, key) => (
                                        <MenuItem value={org.id} key={key}>{`${org.id}, ${org.address}`}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} md={6}>
                            <FormControl className={classes.selectWrapper}>
                                <InputLabel>Тема</InputLabel>
                                <Select
                                    value={this.state.reportSubjectId}
                                    onChange={(e) => this._changeValue(e, "reportSubjectId")}
                                    inputProps={{
                                        name: 'reportSubjectId',
                                    }}
                                    className={classes.select}
                                >
                                    <MenuItem value=""><em>По умолчанию</em></MenuItem>
                                    {this.props.subjects && this.props.subjects.map((org, key) => (
                                        <MenuItem value={org.id} key={key}>{org.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12}>
                            <CustomInput
                                labelText="Описание"
                                formControlProps={{
                                    fullWidth: true,
                                    multiline: true,
                                }}
                                inputProps={{
                                    value: this.state.description,
                                    onChange: e => this._changeValue(e, "description")
                                }}
                            />
                        </GridItem>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.modalFooter} >
                    <Button color="primary"
                            onClick={() => onSave(this.state)}
                    >
                        Сохранить
                    </Button>
                    <Button color="primary" simple
                            onClick={() => onCancel()}
                    >
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

NewReportDialog.propTypes = {
    isOpened: PropTypes.bool,
    machines: PropTypes.array,
    subjects: PropTypes.array,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

NewReportDialog.defaultProps = {
    subjects: [],
    machines: [],
};

export default withStyles(modalStyle)(NewReportDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/NewReportDialog.jsx